import React from 'react';

import { FormikTextField } from 'components';
import { FormFieldProps, GetFieldValidatorFn } from 'types';

import { getTCommon, useTFeature } from '../fields.utils';
import { getBaseFieldValidator, validateIBAN } from '../form.validators';

export const Field: React.FC<FormFieldProps> = ({
  name,
  required = false,
  disabled = false,
}) => {
  const { t } = useTFeature();
  const tCommon = getTCommon();

  return (
    <FormikTextField
      name={name}
      label={t('fields.iban.label')}
      fullWidth
      placeholder={`${tCommon('common.example')}: GB82 WEST 1234 5698 7654 32`}
      required={required}
      disabled={disabled}
    />
  );
};

export const getValidator: GetFieldValidatorFn = ({ required }) => {
  const tCommon = getTCommon();
  return getBaseFieldValidator({ required }).test(
    'iban',
    tCommon('errors.invalid'),
    (value) => validateIBAN(value),
  );
};
